(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  // VALM CUSTOM: Fit the existing hero and its following marquee into the opening viewport.
  class ValmViewportHero extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => {
        this.updateHeight = () => {
          const nextSection = this.closest('.shopify-section')?.nextElementSibling;
          const top = this.getBoundingClientRect().top + window.scrollY;
          const nextHeight = nextSection?.getBoundingClientRect().height || 0;
          this.style.setProperty('--valm-hero-offset', `${top + nextHeight}px`);
          const minimumHeight = Math.max(0, ...Array.from(this.querySelectorAll('.slide__inner'), inner => {
            const content = inner.closest('.slide__content');
            if (!content) return 0;
            const style = getComputedStyle(content);
            return inner.getBoundingClientRect().height + parseFloat(style.paddingTop) + parseFloat(style.paddingBottom) + parseFloat(style.marginTop) + parseFloat(style.marginBottom);
          }));
          this.style.setProperty('--valm-hero-min-height', `${minimumHeight}px`);
        };
        this.observer = new ResizeObserver(this.updateHeight);
        this.observeLayout = () => {
          this.observer.disconnect();
          const nextSection = this.closest('.shopify-section')?.nextElementSibling;
          if (nextSection) this.observer.observe(nextSection);
          document.querySelectorAll('.shopify-section-group-header-group').forEach(header => this.observer.observe(header));
          this.querySelectorAll('.slide__inner').forEach(content => this.observer.observe(content));
          this.updateHeight();
        };
        if (Shopify.designMode) {
          ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(event => document.addEventListener(event, this.observeLayout));
        }
        window.addEventListener('resize', this.updateHeight);
        this.observeLayout();
      });
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      if (this.updateHeight) window.removeEventListener('resize', this.updateHeight);
      if (this.observeLayout) {
        ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(event => document.removeEventListener(event, this.observeLayout));
      }
    }
  }
  if (!customElements.get('valm-viewport-hero')) customElements.define('valm-viewport-hero', ValmViewportHero);

  } catch(e) { console.error(e); }
})();
})();
